$(document).ready(function () {

    $("#form-report-by-branch-office").on('submit', function (e) {
        e.preventDefault();
        console.log('para probar')

        let sucursal = $("#sucursal_name").val();
        let fecha = $("#fecha_inicial").val();

        if ($.trim(sucursal) === "") {
            Swal.fire('Advertencia', 'Seleccione una sucursal', 'error');
            return false;
        }

        if (fecha === "") {
            Swal.fire('Advertencia', 'Seleccione una fecha', 'error');
            return false;
        }

        let data = new FormData(this);

        $.ajax({
            url: "get-transactions-by-branch_office",
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {

                $("#result-transactions_suc").html(response);

                const dataTable = $('#result_suc_transaction').DataTable({
                    "language": {
                        "url": window.location.origin + "/json/Spanish.json"
                    },
                    "order": [[1, 'asc']]
                });
            }
        });

    })


    window.getDetailTransaction = function (button) {

        var serie = button.getAttribute('data-serie');
        var folio = button.getAttribute('data-folio');
        var total = button.getAttribute('data-total');
        var monto = button.getAttribute('data-monto'); // este es desc
        var suc = button.getAttribute('data-suc');


        var formData = new FormData();
        formData.append('serie', serie);
        formData.append('folio', folio);
        formData.append('sucursal_name', suc);
        formData.append('desc', monto);

        $.ajax({
            url: "get-detail-transaction",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $("#MyModal").html(response);
                $('#transactionDetail').modal('show');
            }
        });

    }
})
